import { render, staticRenderFns } from "./MessageListAdvancedTargetingSection.vue?vue&type=template&id=63923fc3&scoped=true&"
import script from "./MessageListAdvancedTargetingSection.vue?vue&type=script&lang=js&"
export * from "./MessageListAdvancedTargetingSection.vue?vue&type=script&lang=js&"
import style0 from "./MessageListAdvancedTargetingSection.vue?vue&type=style&index=0&id=63923fc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63923fc3",
  null
  
)

export default component.exports